import React from 'react';
import Grid from '@mui/material/Grid';
import {
  Link,
  connect,
  TEXTFIELD,
  CircularProgress,
  toast,
  ToastContainer,
  Logo,
  Axios,
  PASSWORDFIELD,
  Row,
  Col,
  SUBMIT,
} from '../components';
import { API_LOGIN } from '../ApiUrl';
import { withRouter } from '../util/withRouter'; // Add this import

import { hideMessage, showAuthLoader, userSignInSuccess, hideAuthLoader } from '../actions/Auth';
import { syncAdminTokenToBackend } from '../services/fcmService';

const engSentance = {
  title: 'Sign In',
  field1: 'Enter Email',
  field2: 'Enter Password',
  button: 'Sign In',
};

const speSentance = {
  title: 'Iniciar sesión',
  field1: 'Ingresar correo electrónico',
  field2: 'Ingresar contraseña',
  button: 'Iniciar sesión',
};

class SignIn extends React.Component {
  constructor() {
    super();
    this.state = {
      email: '',
      password: '',
      errorMessage: '',
      isLanguage: false,
      language: { ...engSentance },
    };
  }

  componentDidUpdate() {
    if (this.props.showMessage) {
      setTimeout(() => {
        this.props.hideMessage();
      }, 100);
    }
    if (this.props.authUser !== null) {
      this.props.navigate('/');
    }
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  loginUser = (e) => {
    e.preventDefault();
    this.props.showAuthLoader();
    const { email, password } = this.state;
    const savedFcmToken = localStorage.getItem('admin_fcm_token');

    const formData = {
      email: email.trim(),
      password: password.trim(),
      ...(savedFcmToken ? { firebaseToken: savedFcmToken } : {}),
    };

    Axios.post(API_LOGIN, formData)
      .then((response) => {
        const data = response.data;

        if (data.status === 'failure') {
          toast.error(data.message);
        } else {
          localStorage.setItem('token', data.data.token);
          localStorage.setItem('_id', data.data._id);
          localStorage.setItem('name', data.data.name);
          localStorage.setItem('role', data.data.role);
          localStorage.setItem('isSuperAdmin', data.data.isSuperAdmin ? 'true' : 'false');
          localStorage.setItem(
            'isSupportChat',
            data.data.isSupportChat !== false ? 'true' : 'false'
          );
          localStorage.setItem('user_id', data.data.token);
          if (savedFcmToken) {
            syncAdminTokenToBackend(savedFcmToken).catch(() => {});
          }
          this.props.userSignInSuccess(data.data.token);
          toast.success('Login successfully.');
          setTimeout(() => {
            this.props.navigate('/app/dashboard/index');
          }, 1000);
        }
        this.props.hideAuthLoader();
      })
      .catch((err) => {
        const error = err.response;
        if (error !== undefined) {
          toast.error(error.data.message);
        } else {
          toast.error('server error, Please try after some time.');
        }
        this.props.hideAuthLoader();
      });
  };

  changeLanguage = () => {
    this.setState((pre) => ({
      isLanguage: !pre.isLanguage,
      language: !pre.isLanguage ? { ...speSentance } : { ...engSentance },
    }));
  };

  render() {
    const { email, password, language } = this.state;
    const { loader } = this.props;
    const isDisabled = !email || !password;
    return (
      <div className="app-login-container d-flex justify-content-center align-items-center animated slideInUpTiny animation-duration-3">
        <div className="app-login-main-content">
          <div className="app-logo-content d-flex align-items-center justify-content-center">
            <Link className="logo-lg" to="/" title="Jambo">
              <img src={Logo} alt="jambo" title="jambo" className="logo" />
            </Link>
          </div>

          <div className="app-login-content">
            <div className="app-login-header mb-4">
              <Grid>
                <Grid item md={6}>
                  <h1>{language.title}</h1>
                </Grid>
              </Grid>
            </div>

            <Row>
              <form onSubmit={(e) => this.loginUser(e)}>
                <Col xm="12">
                  <TEXTFIELD
                    label={language.field1}
                    fullWidth
                    name="email"
                    onChange={this.handleChange}
                    value={email}
                    errors={{}}
                  />
                </Col>
                <Col xm="12">
                  <PASSWORDFIELD
                    label={language.field2}
                    fullWidth
                    name="password"
                    onChange={this.handleChange}
                    value={password}
                    errors={{}}
                  />
                </Col>
                <Col xm="12" md="7">
                  <SUBMIT title={language.button} disabled={isDisabled} />
                </Col>
              </form>
            </Row>
          </div>
        </div>
        {loader && (
          <div className="loader-view">
            <CircularProgress />
          </div>
        )}
        <ToastContainer />
      </div>
    );
  }
}

const mapStateToProps = ({ auth }) => {
  const { loader, alertMessage, showMessage, authUser } = auth;
  return { loader, alertMessage, showMessage, authUser };
};

// Fixed export - wrap with withRouter
export default withRouter(
  connect(mapStateToProps, {
    hideMessage,
    showAuthLoader,
    userSignInSuccess,
    hideAuthLoader,
  })(SignIn)
);
